import React from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import AddSlider from "./add";
import ListSlider from "./list";

const Main = ({ match }) => (
  <Switch>
    <Route path={`${match.url}/add`} component={AddSlider} />
    <Route path={`${match.url}/edit/:id`} component={AddSlider} />
    <Route path={`${match.url}/list`} component={ListSlider} />
    <Route exact path={`${match.url}/`}>
      <Redirect to={`${match.url}/list`} />
    </Route>
  </Switch>
);

export default Main;
